export default {"src":"/_next/static/media/us.b358a5c6.svg","height":18,"width":17,"blurWidth":0,"blurHeight":0};